import React from 'react';

const PersonList = ({ persons, selectedPerson, onPersonSelect, loading }) => {
  if (loading) {
    return (
      <div className="flex-1 p-3 space-y-2 overflow-y-auto">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-14 bg-tech-surface rounded animate-pulse" />
        ))}
      </div>
    );
  }

  if (persons.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="text-center">
          <div className="w-12 h-12 rounded bg-tech-surface border border-tech-border flex items-center justify-center mx-auto mb-3">
            <svg className="w-6 h-6 text-tech-textDim" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
            </svg>
          </div>
          <p className="text-tech-textMuted text-xs font-mono">NO RECORDS FOUND</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto p-2 space-y-1">
      {persons.map((person) => (
        <button
          key={person.id}
          onClick={() => onPersonSelect(person.id)}
          className={`w-full p-3 rounded text-left transition group flex items-center gap-3 ${
            selectedPerson?.id === person.id
              ? 'bg-tech-accent/10 border border-tech-accent/30'
              : 'bg-transparent border border-transparent hover:bg-tech-surface/50 hover:border-tech-border'
          }`}
        >
          <div
            className={`w-10 h-10 rounded flex items-center justify-center font-mono text-sm font-semibold shrink-0 ${
              selectedPerson?.id === person.id
                ? 'bg-tech-accent text-tech-bg'
                : 'bg-tech-surface text-tech-textMuted group-hover:text-tech-text'
            }`}
          >
            {person.name?.charAt(0)?.toUpperCase() || '?'}
          </div>
          <div className="flex-1 min-w-0">
            <p className={`text-sm font-medium truncate ${
              selectedPerson?.id === person.id ? 'text-tech-accent' : 'text-tech-text'
            }`}>
              {person.name}
            </p>
            {person.nickname && (
              <p className="text-tech-textDim text-xs truncate">
                {person.nickname}
              </p>
            )}
          </div>
          {selectedPerson?.id === person.id && (
            <svg className="w-4 h-4 text-tech-accent shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          )}
        </button>
      ))}
    </div>
  );
};

export default PersonList;
